/**
 * @file vehicle-without-orders-card.tsx
 * @module app/modules/orders-delivery/components/delivery-plan/vehicle-without-orders-card
 * @description Read-only accordion card for a vehicle the planner could not assign any
 * order to; header mirrors VehicleRouteCard (driver/vehicle name, no actions) and the
 * expandable body shows the backend's diagnostic reason for the skip.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 2.1.2
 * @version 2.1.2
 */

import { useState } from 'react';
import { Button, Card, Col, Row } from 'react-bootstrap';
import clsx from 'clsx';
import { IMAGES } from '../../../../../utils/assetsAndPermissions';

interface VehicleWithoutOrdersCardProps {
  vehicleVal: any;
}

const VehicleWithoutOrdersCard = ({ vehicleVal }: VehicleWithoutOrdersCardProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const driverName = vehicleVal?.postData?.dModel?.name;
  const vehicleName = vehicleVal?.postData?.vModel?.name;
  const vehicleNumber = vehicleVal?.postData?.vModel?.number;

  return (
    <Col xs={12}>
      <Card className="p-0 bg-light">
        <Card.Header className={clsx('border', isOpen ? '' : 'border-r10px')}>
          <Row className="fs-16 fw-600 align-items-center w-100">
            <Col md className="mb-md-0 mb-5 text-start">
              <Button className="btn-flush btn-white w-100 text-start" variant="">
                <span className={clsx('fw-bolder text-dark')}>
                  {driverName
                    ? `${driverName} / ${vehicleName}-${vehicleNumber}`
                    : vehicleVal?.truckInfo}
                </span>
              </Button>
            </Col>
            <Col md="auto">
              <span className="badge badge-light-danger fs-15 fw-600 text-dark p-3 border-r4px me-5">
                No orders assigned
              </span>
            </Col>
            <Col md="auto">
              <div className="d-flex align-items-center">
                <Button
                  variant="link"
                  className="btn-flush"
                  onClick={() => setIsOpen(!isOpen)}
                >
                  <img src={isOpen ? IMAGES.ArrowUp : IMAGES.ArrowDown} alt="" />
                </Button>
              </div>
            </Col>
          </Row>
        </Card.Header>
        {isOpen ? (
          <Card.Body className="p-5">
            <p className="fs-15 fw-500 mb-0">{vehicleVal?.reasonMessage}</p>
          </Card.Body>
        ) : (
          <></>
        )}
      </Card>
    </Col>
  );
};

export default VehicleWithoutOrdersCard;
